import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { Col, Row } from "reactstrap";
import ButtonComponent from "../../components/ButtonComponent";
import InputComponent from "../../components/InputComponent";
import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/Layout/PageTitle";
import SearchSelectComponent, { SelectItemsProps } from "../../components/SearchSelectComponent";
import Toast from "../../helpers/Toast";
import { Utilities } from "../../helpers/Utilities";
import { AuxiliaryEquipmentDTO } from "../../models/AuxiliaryEquipment/AuxiliaryEquipmentDTO";
import { EditAuxiliaryEquipmentDTO } from "../../models/AuxiliaryEquipment/EditAuxiliaryEquipmentDTO";
import { SearchAuxiliaryEquipmentByModelDTO } from "../../models/AuxiliaryEquipment/SearchAuxiliaryEquipmentByModelDTO";
import { AuxiliaryEquipmentService } from "../../services/AuxiliaryEquipmentService";


export default function AuxiliaryEquipmentEdit() {
  const { erpId } = useParams<{ erpId: string }>();
  const intl = useIntl();
  const [auxiliaryEquipment, setAuxiliaryEquipment] = useState<AuxiliaryEquipmentDTO>({} as AuxiliaryEquipmentDTO);
  const auxiliaryEquipmentService = new AuxiliaryEquipmentService();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  //modelo / marca
  const [modelSelected, setModelSelected] = useState<SelectItemsProps | null>(null);


  const getAuxiliaryEquipment = async () => {
    var response = await auxiliaryEquipmentService.GetAuxiliaryEquipmentByErpId(erpId);
    if (response.success === false || response.obj == null) {
      Toast.Show("error", response.message);
      return;
    }
    setAuxiliaryEquipment(response.obj);

    setModelSelected({
      value: response.obj.brand,
      label: response.obj.model,
    });
  };

  useEffect(() => {
    getAuxiliaryEquipment();
  }, []);

  const EditAuxiliaryEquipment = async () => {

    var data: EditAuxiliaryEquipmentDTO = {
      erpId: auxiliaryEquipment.erpId ?? null,
      description: auxiliaryEquipment.description ?? null,
      serialNumber: auxiliaryEquipment.serialNumber ?? null,
      brand: modelSelected?.value ?? null,
      model: modelSelected?.label ?? null,
      certificationDate: auxiliaryEquipment.certificationDate ?? null,
    };

    setIsLoading(true);
    var response = await auxiliaryEquipmentService.Edit(data);
    if (response.success === false) {
      Toast.Show("error", response.message);
      setIsLoading(false);
      return;
    }



    Toast.Show("success", "Equipamento auxiliar editado com sucesso");
    setIsLoading(false);
  };

  // Obter modelos e meter marca automaticamente
  const getModelByName = async (value: string): Promise<SelectItemsProps[]> => {
    var data: SearchAuxiliaryEquipmentByModelDTO = {
      searchModel: value,
    };
    var response = await auxiliaryEquipmentService.SearchAuxiliaryEquipmentByModel(data);
    if (response.success === false || response.obj === null) {
      Toast.Show("error", response.message);
      return [];
    }

    const list: SelectItemsProps[] = [];

    response.obj.forEach((element: any) => {
      var item: SelectItemsProps = {
        value: `${element.brandCode} - ${element.brandName}`,
        label: `${element.modelCode} - ${element.modelName}`,
      };
      list.push(item);
    });

    return list;
  };

  return (
    <Layout>
      <div className="pageContainer">
        <div className="pageHeader">
          <PageTitle
            title={intl.formatMessage({ id: 'Screens.ProjectEdit.Title' })}
            dynamicTitle={() => `Equipamento Auxiliar - ${auxiliaryEquipment?.erpId}`}
            allowGoBack={true}
          />
        </div>
        <div className="pageBody">
          <Row style={{ margin: "0px", padding: "0px", alignItems: "flex-start", alignContent: "flex-start" }}>
            <Col xl={6}>
              <Row>
                <InputComponent
                  xl={12}
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  style={{ width: "100%" }}
                  type={"text"}
                  value={auxiliaryEquipment.description}
                  label={intl.formatMessage({ id: "Screens.AuxiliaryEquipments.Info.Description" })}
                  readOnly={false}
                  showLoadingSkeleton={isLoading}
                  onChange={(t: string) => {
                    setAuxiliaryEquipment({ ...auxiliaryEquipment!, description: t });
                  }}
                />
              </Row>
              <Row>
                <InputComponent
                  xl={4}
                  lg={4}
                  md={4}
                  sm={12}
                  xs={12}
                  style={{ width: "100%" }}
                  type={"text"}
                  value={auxiliaryEquipment.serialNumber}
                  label={intl.formatMessage({ id: "Screens.AuxiliaryEquipments.Info.NumSerie" })}
                  readOnly={false}
                  showLoadingSkeleton={isLoading}
                  onChange={(t: string) => {
                    setAuxiliaryEquipment({ ...auxiliaryEquipment!, serialNumber: t });
                  }}
                />
              </Row>
              <Row>
                <InputComponent
                  xl={4}
                  lg={4}
                  md={4}
                  sm={12}
                  xs={12}
                  style={{ width: "100%" }}
                  type={"text"}
                  value={modelSelected?.value}
                  label={intl.formatMessage({ id: "Screens.AuxiliaryEquipments.Info.Brand" })}
                  readOnly={true}
                  showLoadingSkeleton={isLoading}
                // onChange={(t: string) => {
                //   setAuxiliaryEquipment({ ...auxiliaryEquipment!, brand: t });
                // }}
                />
                {/* Vamos substituir pelo search component */}
                <SearchSelectComponent
                  xl={8}
                  lg={8}
                  md={8}
                  sm={12}
                  xs={12}
                  label={intl.formatMessage({
                    id: "Screens.AuxiliaryEquipments.Info.Model",
                  })}
                  loadOptions={getModelByName}
                  onChange={(e) => {
                    setModelSelected(e);
                    setAuxiliaryEquipment({ ...auxiliaryEquipment!, brand: e.label });
                  }}
                  value={modelSelected}
                  style={{ width: "100%" }}
                  isDisabled={isLoading}
                />
              </Row>
              <Row>
                <InputComponent
                  xl={3}
                  lg={3}
                  md={3}
                  sm={12}
                  xs={12}
                  style={{ width: "100%" }}
                  type={"date"}
                  value={auxiliaryEquipment.certificationDate == null ? "" : Utilities.formatDateYYYYMMDD(new Date(auxiliaryEquipment.certificationDate))}
                  label={intl.formatMessage({ id: "Screens.AuxiliaryEquipments.Info.CertificationDate" })}
                  readOnly={false}
                  showLoadingSkeleton={isLoading}
                  onChange={(t: Date) => {
                    setAuxiliaryEquipment({ ...auxiliaryEquipment!, certificationDate: t });
                  }}
                />
              </Row>
              <Row style={{ margin: "0px", padding: "0px", justifyContent: "end" }}>
                <Col xl={3} lg={3} md={3} sm={12} xs={12}>
                  <ButtonComponent
                    style={{ width: "100%", marginTop: "10px" }}
                    text={intl.formatMessage({ id: "AssistanceEditA.Save" })}
                    onClick={() => EditAuxiliaryEquipment()}
                    disabled={isLoading}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </Layout >
  );
}